import {
  DEFAULT_LIMIT,
  fetchAllCursorPages,
  schedulingDelete,
  schedulingGet,
  schedulingPost,
  schedulingPut,
  versionBody,
} from "./client";

export function listServiceCategories({
  organizationRef,
  scope,
  excludedOrganizationRefs,
  practitionerRef,
  serviceCategoryId,
  code,
  active,
  search,
  cursor,
  limit = DEFAULT_LIMIT,
  signal,
  consistency,
}) {
  return schedulingGet("serviceCategory", {
    organizationRef,
    scope,
    excludedOrganizationRefs,
  practitionerRef,
    serviceCategoryId,
    code,
    active,
    search,
    cursor,
    limit,
  }, { signal, consistency });
}

export function getServiceCategory({ organizationRef, serviceCategoryId, code }) {
  return schedulingGet("serviceCategory", {
    organizationRef,
    serviceCategoryId,
    code,
  }, { consistency: "strong" });
}

export async function listAllServiceCategories(params) {
  return fetchAllCursorPages({
    signal: params.signal,
    itemsKey: "serviceCategories",
    fetchPage: (cursor) => listServiceCategories({ ...params, cursor }),
  });
}

export function createServiceCategory(body) {
  return schedulingPost("serviceCategory", body);
}

export function updateServiceCategory(body) {
  const { expectedVersion, ...rest } = body;
  return schedulingPut("serviceCategory", {
    ...rest,
    ...versionBody(expectedVersion),
  });
}

export function deactivateServiceCategory({ organizationRef, serviceCategoryId, expectedVersion }) {
  return schedulingDelete("serviceCategory", {
    organizationRef,
    serviceCategoryId,
    ...versionBody(expectedVersion),
  });
}
